import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBehaviorPhishingReports = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.89931 9.27993L9.87531 10.2146M12.8825 9.02976C12.8825 12.9422 7.99984 14.3613 7.99984 14.3613C7.99984 14.3613 3.11783 12.9428 3.11783 9.02976C3.11783 5.11664 2.93984 4.81091 3.33184 4.43478C3.72451 4.05808 7.35984 2.84131 7.99984 2.84131C8.64051 2.84131 12.2752 4.05494 12.6672 4.43478C13.0598 4.81404 12.8825 5.11728 12.8825 9.02976ZM7.58057 6.05631C8.65124 6.05631 9.51931 6.88947 9.51931 7.91692C9.51931 8.94444 8.65124 9.77696 7.58057 9.77696C6.51061 9.77696 5.64262 8.94444 5.64262 7.91692C5.64262 6.88947 6.51061 6.05631 7.58057 6.05631Z",
		stroke: "#596180",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBehaviorPhishingReports;
